import { supabase } from '@/lib/supabase';

export interface AdminAiUsageOrgRow {
  organization_id: string;
  org_name: string;
  plan_code: string;
  plan_included: number;
  used_this_period: number;
  plan_credits_remaining: number;
  topup_credits_remaining: number;
  granted_credits: number;
  quota_pct: number;
  topup_revenue_agorot: number;
  credits_used: number;
  cost_agorot: number;
  call_count: number;
  gross_margin_agorot: number;
  last_activity: string | null;
}

export interface AdminAiUsageTrendPoint {
  day: string;
  credits: number;
  cost_agorot: number;
}

export interface AdminAiUsageTotals {
  credits_used: number;
  cost_agorot: number;
  topup_revenue_agorot: number;
  gross_margin_agorot: number;
  org_count: number;
}

export interface AdminAiUsageReport {
  orgs: AdminAiUsageOrgRow[];
  trend: AdminAiUsageTrendPoint[];
  totals: AdminAiUsageTotals;
}

export interface OrgAiUsagePerDay {
  day: string;
  credits: number;
  calls: number;
}

export interface OrgAiUsagePerAction {
  action_code: string;
  credits: number;
  calls: number;
}

export interface OrgAiUsageHistoryRow {
  id: string;
  created_at: string;
  action_code: string;
  user_name: string;
  credits: number;
  model: string;
}

export interface OrgAiUsageReport {
  per_day: OrgAiUsagePerDay[];
  per_action: OrgAiUsagePerAction[];
  history: OrgAiUsageHistoryRow[];
}

export const aiUsageApi = {
  adminReport: async (
    from: string,
    to: string,
    planCode?: string | null,
    search?: string | null,
  ): Promise<AdminAiUsageReport> => {
    const { data, error } = await supabase.rpc('admin_ai_usage_report', {
      p_from: from,
      p_to: to,
      p_plan_code: planCode ?? null,
      p_search: search ?? null,
    });
    if (error) throw error;
    return (data ?? { orgs: [], trend: [], totals: { credits_used: 0, cost_agorot: 0, topup_revenue_agorot: 0, gross_margin_agorot: 0, org_count: 0 } }) as AdminAiUsageReport;
  },

  orgReport: async (orgId: string, from: string, to: string): Promise<OrgAiUsageReport> => {
    const { data, error } = await supabase.rpc('ai_usage_report', {
      p_org: orgId,
      p_from: from,
      p_to: to,
    });
    if (error) throw error;
    return (data ?? { per_day: [], per_action: [], history: [] }) as OrgAiUsageReport;
  },
};
